import { render, staticRenderFns } from "./CompareHeader.vue?vue&type=template&id=15f95198&scoped=true"
import script from "./CompareHeader.vue?vue&type=script&lang=js"
export * from "./CompareHeader.vue?vue&type=script&lang=js"
import style0 from "./CompareHeader.vue?vue&type=style&index=0&id=15f95198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f95198",
  null
  
)

export default component.exports